import { A } from '@solidjs/router';
import { onMount, Show, type JSX } from "solid-js";
import { useUserContext } from "../components/UserContextProvider";
import { useLoadCurrentUser } from "../hooks/useLoadCurrentUser";
import { useSFetch } from "../hooks/sfetch";
import { useTranslation } from "../hooks/useTranslation";
import LanguageChooser from "../components/LanguageChooser";
import Text from "../components/Text";
import styles from './AdminTopbar.module.css';

interface AdminTopbarProps {
    children: any;
    menuButton?: JSX.Element;
}

export default function AdminTopbar(props: AdminTopbarProps) {

    const { user, setUser } = useUserContext();
    const loadCurrentUser = useLoadCurrentUser({ onboarding: false });
    const sfetch = useSFetch();
    const { t } = useTranslation();

    onMount(() => {
        void loadCurrentUser();
    });

    function logout() {
        sfetch("/api/User/Logout", { method: "GET" }).then(() => {
            setUser(prev => ({ ...prev, loggedin: false }));
        });
    }

    return (
        <>
            <div class={styles.topbar}>
                <div class={styles.left}>
                    {props.menuButton}
                    <A href="/admin" aria-label="Vektor Admin" class={styles.brand}>
                        <img class={styles.logo} src={"/vektor_anim.svg"} />
                        <span class={styles.wordmark}>Vektor</span>
                        <span class={styles.badge}><Text val="ADMIN" /></span>
                    </A>
                </div>
                <div class={styles.right}>
                    <Show when={user().loggedin}>
                        <span class={styles.username}>{user().username}</span>
                        <button type="button" class={styles.logoutBtn} onClick={logout} title={t('LOGOUT')} aria-label={t('LOGOUT')}>
                            <i class="fa-solid fa-right-from-bracket" />
                        </button>
                    </Show>
                    <LanguageChooser></LanguageChooser>
                </div>
            </div>
            <div class="navbar-content">
                {props.children}
            </div>
        </>
    );
}
